import { render, staticRenderFns } from "./AdvisePdf.vue?vue&type=template&id=89ec3c0a"
import script from "./AdvisePdf.vue?vue&type=script&lang=js"
export * from "./AdvisePdf.vue?vue&type=script&lang=js"
import style0 from "./AdvisePdf.vue?vue&type=style&index=0&id=89ec3c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports